<nav class="breadcrumb" aria-label="Breadcrumb">
  @if (breadcrumbs.length > 1 && !hasUnresolvedPlaceholders) {
    @for (crumb of breadcrumbs; track crumb.url; let last = $last) {
      @if (!last) {
        <a class="breadcrumb-link" (click)="navigateTo($index)">{{ crumb.label }}</a>
        <span class="breadcrumb-separator">&#x203A;</span>
      } @else {
        <span class="breadcrumb-current">{{ crumb.label }}</span>
      }
    }
  }
</nav>
